export class DropdownSelectorController extends window.StimulusController {
  static targets = ["inputField", "form", "list"];

  connect() {
    document.addEventListener("click", this.#handleClickOutside);
  }

  disconnect() {
    document.removeEventListener("click", this.#handleClickOutside);
  }

  #handleClickOutside = (event) => {
    if (!this.hasListTarget) {
      return;
    }

    const isHidden = this.listTarget.classList.contains("tw-opacity-0");

    if (isHidden) {
      return;
    }

    if (!this.element.contains(event.target)) {
      this.toggleVisibility();
    }
  };

  toggleVisibility() {
    this.listTarget.classList.toggle("tw-opacity-0");
    this.listTarget.classList.toggle("tw-pointer-events-none");
  }

  submit(event) {
    event.preventDefault();
    const value = event.currentTarget.getAttribute("value");
    this.inputFieldTarget.value = value;
    this.formTarget.submit();
  }
}

Stimulus.register("dropdownSelector", DropdownSelectorController);
